import './_cart-item.scss';
import component from './cart-item';

export default component;
